import React, { useEffect, useState } from 'react'
import { ChevronDown, ShoppingCart } from 'react-feather'
import { useLocale } from 'src/lib/hooks/useLocal'
import { OrderSummaryConfigType } from 'src/lib/types/customizeUI'
import { ItemCard } from './ItemCard'

interface PreviewOrderSummaryProps {
  orderSummaryConfig: OrderSummaryConfigType
}

const PreviewOrderSummary: React.FC<PreviewOrderSummaryProps> = ({ orderSummaryConfig }) => {
  const { t } = useLocale()
  const [active, setActive] = useState(orderSummaryConfig.isQuantityEditable || orderSummaryConfig.isOrderSummaryOpen)

  useEffect(() => {
    if (Boolean(orderSummaryConfig.isQuantityEditable || orderSummaryConfig.isOrderSummaryOpen)) {
      setActive(true)
      return
    }
    setActive(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderSummaryConfig])

  const toggleAccordion = () => {
    setActive(prevState => !prevState)
  }

  return (
    <div
      className={`border-1 border-gray-light rounded-2xl w-full flex flex-col bg-white ${
        active ? 'shadow-[0px_0px_10px_0px_rgba(0,0,0,0.05)] duration-200 ease-in-out' : 'delay-[100ms]'
      }`}
    >
      <button
        className={`flex h-[3.25rem] w-full cursor-pointer flex-row items-center rounded-[inherit] px-3 py-4 focus:outline-none `}
        onClick={toggleAccordion}
      >
        <div className='flex w-full flex-row items-center justify-between'>
          <div className='flex flex-row items-center space-x-2'>
            <ShoppingCart className='w-4 h-4' />
            <p className='text-sm font-medium text-coal-dark'>{t('order_summary')}</p>
          </div>
          <div className='flex flex-row gap-2'>
            <p className='text-sm text-coal-light'>{t('items', { count: 3 })}</p>

            <ChevronDown
              className={`h-4 w-4 text-coal-dark ${
                active ? `rotate-180 transform duration-700 ease-in-out` : `rotate-0 transform duration-700 ease-in-out`
              }`}
            />
          </div>
        </div>
      </button>
      <div
        className={`overflow-hidden transition-[max-height] ${
          active ? `duration-700 ease-in` : `duration-500 ease-out`
        } ${active ? `max-h-[9999px]` : ` max-h-0`} `}
      >
        <div className='p-4 flex flex-col space-y-4'>
          <ItemCard orderSummaryConfig={orderSummaryConfig} />
          <ItemCard orderSummaryConfig={orderSummaryConfig} />
          <ItemCard orderSummaryConfig={orderSummaryConfig} />
        </div>
      </div>
    </div>
  )
}

export default PreviewOrderSummary
